<template>
  <figure class="image">
    <video class="has-ratio" :src="video.url" controls loop></video>

  </figure>
</template>

<script>
export default {
  name: "TweetVideo",
  props: {
    video: Object
  }
}
</script>

<style scoped>
  video {
    width: 100%;
    border-radius: 0.5rem;
    cursor: pointer;
  }

  .content figure {
    margin-left: 0;
    margin-right: 0;
  }
</style>
